import React from "react";

import { useMediaQuery } from "@braintrust/braintrust-ui-components";

import { PublicTopNavigationDesktop } from "./public-top-navigation-desktop";
import { PublicTopNavigationMobile } from "./public-top-navigation-mobile";

export const PublicTopNavigation = () => {
  const isMobile = useMediaQuery("lg");

  return isMobile ? (
    <PublicTopNavigationMobile />
  ) : (
    <PublicTopNavigationDesktop />
  );
};
